import transportationService from '../../service/transportationsResource';
import { format } from 'date-fns';
const initalState = {
  employeesModal: false,
  transportationModal: false,
  transportations: [],
  transportationLoading: false,
  carsModal: false,
  page: 0,
  sortModel: [],
  pageCount: 0,
  loadingLocationData: false,
  locationData: [],
  multiPolylines: { greenPolylines: [], redPolylines: [] },
};

export const createTransportationTab = (set, get) => ({
  ...initalState,
  toggleEmployeesModal: () => {
    set({ employeesModal: !get().employeesModal });
  },
  openTransportationModal: () => set({ transportationModal: true }),
  closeTransportationModal: () => set({ transportationModal: false }),
  toggleTransportationModal: () =>
    set({ transportationModal: !get().transportationModal }),
  carsModal: false,

  resetModals: () => {
    set({
      carsModal: false,
      transportationModal: false,
      employeesModal: false,
    });
  },
  toggleCarsModal: () => {
    return a.set({ carsModal: !get().carsModal });
  },
  setPage: (e) => set({ page: e }),
  setPage: (page) => set({ page }),
  setSortModel: (sortModel) => set({ sortModel: sortModel }),
  setCarsModalOpen: () => set(() => ({ carsModal: true })),
  setCarsModalClose: () => set(() => ({ carsModal: false })),
  toggleCarsModal: () => {
    return set(() => ({ carsModal: !get().carsModal }));
  },
  fetchTransportationData: async (data) => {
    set({ error: '' });
    const sortModel = get().sortModel;
    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1, query, isMobile } = data;

    try {
      set({ transportationLoading: true });
      const params = {
        query: encodeURI(query),
        size: isMobile ? 5 : 10,
        page: get().page,
        sort: `${field},${sort}`,
        t0: format(new Date(t0), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        t1: format(new Date(t1), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
      };
      const result =
        await transportationService.getAllTransportationWithSearch(params);
      const data = result?.data?.data;
      const properties = result?.data?.properties;
      set({
        pageCount:
          properties?.totalPages === null || 0 ? 1 : properties.totalPages,
      });
      set({ transportations: data === null ? [] : data });
    } catch (error) {
      console.error(error);
      set({ transportations: [] });
    } finally {
      set({ transportationLoading: false });
    }
  },
  fetchLocationData: async (id) => {
    set({ error: '' });
    try {
      set({ loadingLocationData: true });
      const result = await transportationService.findAllByMCodeAndMtId(id);
      const data = result?.data?.data;
      // const preapareMultiPolylines = (data) => {
      //   const speedWall = 60;
      //   let greenPolylines = [];
      //   let redPolylines = [];
      //   let tempPolylines = [];
      //   for (let index = 1; index < data.length; index++) {
      //     let a = data[index];
      //     let b = data[index - 1];
      //     if (parseInt(a.speed) > speedWall) {
      //       if (parseInt(b?.speed) < speedWall) {
      //         greenPolylines.push(tempPolylines);
      //         tempPolylines = [];
      //         tempPolylines.push(a);
      //       } else {
      //         if (index === data.length - 1) {
      //           greenPolylines.push(tempPolylines);
      //         } else {
      //           tempPolylines.push(a);
      //         }
      //       }
      //     } else {
      //       if (parseInt(b?.speed) > speedWall) {
      //         redPolylines.push(tempPolylines);
      //         tempPolylines = [];
      //         tempPolylines.push(a);
      //       } else {
      //         if (index === data.length - 1) {
      //           redPolylines.push(tempPolylines);
      //         } else {
      //           tempPolylines.push(a);
      //         }
      //       }
      //     }
      //   }
      //   return { greenPolylines, redPolylines };
      // };
      if (data.length === 0 || data === null) {
        get().setError('Kordinat bilgisi bulunamadı.');
      }
      set({ locationData: data });
      get().resetAllLayerExceptOne('LRoutes', data);
      // set({ multiPolylines: preapareMultiPolylines(data) });
    } catch (error) {
      set({ locationData: [] });
      console.error(error);
    } finally {
      set({ loadingLocationData: false });
    }
  },
  resetToInitalState: () => {
    set(initalState);
  },
});
